import { FeatureAppLoader } from '@feature-hub/react';
import React from 'react';
import { PortalContext } from '../../context/portal-context';
import { Breakpoints, Layout } from '@volkswagen-onehub/components-core';
import type { FeatureAppConfiguration } from '@volkswagen-onehub/featureapp-service';

export const LoaderFeedback: React.FC<{}> = () => {
	const { featureAppService } = React.useContext(PortalContext);
	const oneformFeedback = featureAppService.featureAppConfigurations['es-oneform-feedback'] as
		| FeatureAppConfiguration
		| undefined;

	return (
		<Layout
			appearance={{
				[Breakpoints.default]: [
					{ name: '.', columns: 1 },
					{ name: 'a', columns: 22 },
					{ name: '.', columns: 1 },
				],
			}}
		>
			{oneformFeedback && (
				<FeatureAppLoader
					{...oneformFeedback}
					featureAppId={`${oneformFeedback.name}:oneform`}
					done={() => {}}
					beforeCreate={(env) => {
						const featureServices = env.featureServices as Record<string, any>;
						if (featureServices['fa-content-service']) {
							featureServices['fa-content-service'].content = {
								feedback: 'PORTAL',
								idkit: 'true',
								climapro: 'true',
								headline: 'Queremos saber tu opinión: ¿recomendarías el Club Volkswagen a un amigo?',
							};
						}
						if (featureServices['api-key-provider']) {
							featureServices['api-key-provider'].apiKey = oneformFeedback.apiKey;
						}
					}}
				/>
			)}
		</Layout>
	);
};
